/**
 * Колонки канбана стартовой (AS-2000):
 * Pre-access / Access / Post-access.
 * Подписи чипов и колонок — только EN (как в макете, без перевода).
 */

export const HOME_BU_FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'Oncology', label: 'Oncology' },
  { key: 'Biopharma', label: 'Biopharma' },
  { key: 'Immunology', label: 'Immunology' },
  { key: 'Rare Genetics', label: 'Rare Genetics' },
  { key: 'Rare Complement', label: 'Rare Complement' },
  { key: 'New Modalities', label: 'New Modalities' },
]

export const HOME_KANBAN_COLUMNS = [
  {
    id: 'plan',
    title: 'Pre-access brands',
    titleKey: 'kanban.preAccess',
    tone: 'plan',
    sources: [
      {
        key: 'new_maa',
        label: 'Planned New MAA',
        labelKey: 'pipeline.newMaa',
        category: 'planned_maa',
        pipelineMode: 'new_maa',
        dateMode: 'planned',
        tagTone: 'plan',
      },
      {
        key: 'submitted_new_maa',
        label: 'Submitted New MAA',
        labelKey: 'pipeline.submittedNewMaa',
        category: 'new_maa_registration',
        dateMode: 'registration',
        tagTone: 'plan',
      },
    ],
  },
  {
    id: 'registration',
    title: 'Access brands',
    titleKey: 'kanban.access',
    tone: 'registration',
    sources: [
      {
        key: 'new_indications',
        label: 'New Indication',
        labelKey: 'pipeline.newIndications',
        // Access: Critical MoH + new_indication + без Full Access.
        category: 'post_approval',
        pipelineMode: 'new_indications',
        dateMode: 'variation',
        tagTone: 'registration',
      },
      {
        key: 'variation',
        label: 'Variation',
        labelKey: 'pipeline.variation',
        // Access: Critical MoH + без Full Access.
        category: 'post_approval',
        dateMode: 'variation',
        tagTone: 'registration',
      },
    ],
  },
  {
    id: 'registered',
    title: 'Post-access brands',
    titleKey: 'kanban.postAccess',
    tone: 'registered',
    sources: [
      {
        key: 'variation',
        label: 'Variation',
        labelKey: 'pipeline.variation',
        // Post-access: Critical MoH + Full Access (category API: registered).
        category: 'registered',
        dateMode: 'variation',
        tagTone: 'registered',
      },
    ],
  },
]

export function buildHomeKanbanQuery({ category, pipelineMode, search, onPage = 500 }) {
  const filters = ['card_category']
  const filterIds = [category]
  if (category === 'planned_maa') {
    filters.push('pipeline_mode')
    filterIds.push(pipelineMode || 'new_maa')
  } else if (category === 'post_approval' && pipelineMode) {
    // Access → New Indication: post_approval + pipeline_mode=new_indications
    filters.push('pipeline_mode')
    filterIds.push(pipelineMode)
  }
  const next = {
    page: 1,
    onPage,
    filter: filters.join('&&'),
    filter_id: filterIds.join('&&'),
    search_min_length: 1,
  }
  const q = String(search || '').trim()
  if (q) {
    next.search = q
  }
  return next
}

/** Совпадение BU-фильтра макета с product.bu. */
export function productMatchesBu(row, buKey) {
  if (!buKey || buKey === 'all') {
    return true
  }
  const bu = row?.bu
  if (!bu) {
    return false
  }
  const candidates = [bu.value, bu.key, bu.name, bu.label]
    .filter(Boolean)
    .map(v => String(v).trim().toLowerCase())
  const target = String(buKey).trim().toLowerCase()
  return candidates.some(c => c === target || c.includes(target) || target.includes(c))
}
